import React, { useState, useEffect } from "react";
import { 
  GridComponent, 
  ColumnsDirective, 
  ColumnDirective, 
  Page, 
  Toolbar, 
  Inject 
} from "@syncfusion/ej2-react-grids";
import { toast } from "react-hot-toast";
import { IoCloudDownload, IoArrowBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { getUserNameData } from "../api/Api";
import { useAuth } from "../contexts/AuthContext";
import NavBar from "../components/Navbar/NavBar";

function UserDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  
  const { userData } = useAuth();
  const loadData = () => {
      if (!userData?.email) {
      toast.error("User email not available");
      return;
    }

    setLoading(true);
    getUserNameData(userData.email)
      .then((res) => {
        console.log("API Response:", res.data);
        if (res.data) {
          setData([res.data]);
          toast.success("Data loaded successfully");
        } else {
          toast.error("No data available");
        }
      })
      .catch((error) => {
        console.error("Error loading data:", error);
        toast.error(error.message || "Failed to load data");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  useEffect(() => {
    loadData();
  }, [userData?.email]);


  const actionTemplate = (props) => {
    return (
      <Link
        to={{
          pathname: "/viewOrderList",
          state: {
            name: props.name,
            email: props.pupilEmail,
          }
        }}
      >
        <button
          className="px-2 text-sm border-1 border-brightColor bg-backgroundColor hover:text-brightColor transition-all rounded-lg font-bold uppercase"
          type="button"
          disabled={loading}
        >
          <IoCloudDownload />
        </button>
      </Link>
    );
  };

  const paymentStatusTemplate = (props) => {
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
        props.paymentStatus === 'PAID' 
          ? 'bg-green-100 text-green-800' 
          : 'bg-red-100 text-red-800'
      }`}>
        {props.paymentStatus}
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />
      <div className="pt-28 pb-16 px-4 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => navigate("/")}
            className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
          >
            <IoArrowBack className="mr-1" />
            Back
          </button>
          <h2 className="text-2xl font-semibold text-gray-800">
            {userData?.name ? `${userData.name}'s Dashboard` : 'My Dashboard'}
          </h2>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          {loading ? (
            <div className="text-center py-8">Loading data...</div>
          ) : data.length === 0 ? (
            <div className="text-center py-8">No data available</div>
          ) : (
            <div className="control-section">
              <GridComponent
                dataSource={data}
                allowPaging={true}
                pageSettings={{ pageCount: 5, pageSize: 10 }}
                selectionSettings={{ persistSelection: true }}
                toolbar={["Search"]}
                loading={loading}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="name"
                    headerText="Name"
                    width="150"
                    textAlign="Center"
                  />
                  <ColumnDirective
                    field="pupilEmail"
                    headerText="Email"
                    width="200"
                    textAlign="Center"
                  />
                  <ColumnDirective
                    field="pupilMobile"
                    headerText="Mobile No"
                    width="150"
                    textAlign="Center"
                  />
                  <ColumnDirective
                    field="planName"
                    headerText="Plan Name"
                    width="150"
                    textAlign="Center"
                  />
                  <ColumnDirective
                    field="planCost"
                    headerText="Plan Cost"
                    width="120"
                    textAlign="Center"
                    format="C2"
                  />
                  <ColumnDirective
                    field="planDuration"
                    headerText="Duration"
                    width="120"
                    textAlign="Center"
                  />
                  <ColumnDirective
                    field="paymentStatus"
                    headerText="Payment Status"
                    width="150"
                    textAlign="Center"
                    template={paymentStatusTemplate}
                  />
                  <ColumnDirective
                    headerText="Actions"
                    width="120"
                    textAlign="Center"
                    template={actionTemplate}
                  />
                </ColumnsDirective>
                <Inject services={[Page, Toolbar]} />
              </GridComponent>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDashboard;